import React from 'react';
import { FormGroup, FormGroupProps, FormText, FormTextProps, Row, Col, FormLabel } from 'react-bootstrap';
import { FormikCheck, FormikCheckProps } from '../';

type FormGroupCheckProps = FormikCheckProps & {
  name: string;
  feedback?: string;
  help?: string;
  groupProps?: FormGroupProps;
  helpProps?: FormTextProps;
  asRow?: boolean;
};

const FormGroupCheck = ({
  help,
  label,
  groupProps,
  helpProps,
  asRow = false,
  ...props
}: FormGroupCheckProps) => {
  if (asRow) {
    return (
      <FormGroup as={Row} {...groupProps}>
        <FormLabel column sm={4}>
          {label}
        </FormLabel>
        <Col sm>
          <FormikCheck {...props} />
          {help && (
            <FormText muted {...helpProps}>
              {help}
            </FormText>
          )}
        </Col>
      </FormGroup>
    );
  }

  return (
    <FormGroup {...groupProps}>
      <FormikCheck {...props} label={label} />
      {help && (
        <FormText muted {...helpProps}>
          {help}
        </FormText>
      )}
    </FormGroup>
  );
};

export { FormGroupCheck, FormGroupCheckProps };
